<template>
  <div class="DefaultProductItem">
    <ul class="content_page">
      <li>
        <div class="content_page_header">
          <span></span>
          <span></span>
        </div>
        <div class="content_page_footer">
          <div class="content_page_footer_head">
            <div></div>
            <div></div>
          </div>
          <div class="content_page_footers">
            <div></div>
          </div>
        </div>
      </li>
      <li>
        <div class="content_page_header">
          <span></span>
          <span></span>
        </div>
        <div class="content_page_footer">
          <div class="content_page_footer_head">
            <div></div>
            <div></div>
          </div>
          <div class="content_page_footers">
            <div></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'DefaultProductItem',
  data() {
    return {};
  },
};
</script>
<style scoped>
.content_page {
  width: 100%;
  height: 300px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
}
.content_page li:nth-child(1) {
  width: 335px;
  height: 120px;
  background: #f4f4f4;
  margin-bottom: 10px;
  margin-top: -36px;
}
.content_page li:nth-child(2) {
  width: 335px;
  height: 120px;
  background: #f4f4f4;
}
.content_page_header {
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
}
.content_page_header span:nth-child(1) {
  display: block;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #eaeaea;
  margin: 0 10px 0 10px;
}
.content_page_header span:nth-child(2) {
  display: block;
  width: 110px;
  height: 22px;
  background: #eaeaea;
}
.content_page_footer {
  width: 100%;
  height: 75px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.content_page_footer_head {
  width: 270px;
  height: 75px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.content_page_footer_head div:nth-child(1) {
  width: 270px;
  height: 22px;
  background: #eaeaea;
  margin: 0 0 10px 16px;
}
.content_page_footer_head div:nth-child(2) {
  width: 270px;
  height: 22px;
  background: #eaeaea;
  margin: 0 0 10px 16px;
}
.content_page_footers {
  width: 75px;
  height: 75px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.content_page_footers div {
  width: 38px;
  height: 22px;
  background: #eaeaea;
}
</style>
